import { CustomFilterPillProps } from "../../SharedComponents/Interfaces/CustomFilterPill.interfaces";
import { createFilterPill, mapPartnerFilterPillMenuItemsPredicate } from "./PartnerSearch.common";

export const PARTNER_FILTER_PILL = {
  INITIAL_STATE: { menuItems: [], selectedMenuItems: [] },
  INITIAL_FILTER_VALUES: ["Yes", "No"].map(mapPartnerFilterPillMenuItemsPredicate),
  INITIAL_DATA: [
    createFilterPill("partnerCountry", "PartnerCountry"),
    createFilterPill("isElite", "IsElite"),
    createFilterPill("isChannelPartner", "IsChannelPartner"),
    createFilterPill("isDefault", "IsDefault")
  ] as CustomFilterPillProps[]
};

export const COPY_TITLE = "Copy MPN ID/PartnerOne ID";

export const PARTNER_DATA_GRID_CONFIG = {
  rows: {
    count: 0,
    values: [],
    size: 0,
    skip: 0
  },
  pagination: {
    pageSize: 25,
    page: 0
  }
};

export const CCP_PARTNER_PROGRAM_URL = "https://microsoft.sharepoint.com/sites/CxECustomerCommunitiesandPartner/SitePages/Security-Elite-Partner-Program.aspx";

export const PAU_IDEAS_URL = "https://nam06.safelinks.protection.outlook.com/?url=https:%2f%2feng.ms%2fdocs%2fexperiences-devices%2fdata-platform-growth%2fideas%2fideas-wiki%2fdata-platform%2ffoundational-assets%2fprofiles%2fcommercial%2ftenant-profile-view%2fideaspau&data=05%7c02%7cSita.Muthusamy%40microsoft.com%7cfc8f1a1c5c1d47bed14a08de11b4e7c6%7c72f988bf86f141af91ab2d7cd011db47%7c1%7c0%7c638967665967257385%7cUnknown%7cTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7c0%7c%7c%7c&sdata=4DLcKQQyJmXUSRaHwNAEIuXAWY6V28i2MIqTCfgLdX0%3D&reserved=0";

export const tooltipTexts = {
  partnerID: "Microsoft Partner Network ID (MPNID)",
  partnerName: "Microsoft Partner Network Name (MPNName)",
  partnerOneId: "PartnerOne ID",
  partnerOneName: "PartnerOne Name",
  partnerCountry: "Partner's Country as per PartnerOne records",
  isDefault: "Indicates if the PartnerId and PartnerOneID mapping are same",
  isCPOR: "Indicates if the Partner is a CPOR partner",
  isCSP: "Indicates if the Partner is a CSP partner",
  isPAL: "Indicates if the Partner is a PAL partner",
  cporTenantsCount: "Number of CPOR Tenants associated with the Partner",
  cspTenantsCount: "Number of CSP Tenants associated with the Partner",
  palTenantsCount: "Number of PAL Tenants associated with the Partner",
  cporPartnerReach:"Sum of Entra login MAU of CPOR Tenants associated with the Partner",
  cspPartnerReach:"Sum of Entra login MAU of CSP Tenants associated with the Partner",
  palPartnerReach:"Sum of Entra login MAU of PAL Tenants associated with the Partner",
  cporWorkloadCount: "Distinct Workloads Partner is involved in across Tenants",
  cspSubscriptionCount: "Number of unique subscriptions the Partner is associated with",
  palServicesCount: "Distinct count of Security product related services Partner is associated with through PAL",
  totalPAU: "Paid Available Units (abbreviated as PAU) is the measure of paid licenses on a Tenant. It is an equivalent of paid seats measured by Finance teams but it addresses the monthly fluctuations in paid seats caused by business rhythms. Paid license means there is revenue associated with the license."
};